import React, { useState } from "react";
import './EndOfDayBox.css'
import TitleText from "./TitleText";
import SelectOption from './SelectOption';
import {
    urlFor,
    postJson,
    RequestEndOfDay,
    TARGET_END_OF_DAY,
    OverallLevel
} from "../utils/comms";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { delayEOD, getAccessToken, resetEOD } from "../utils/cookies";
import TextArea from "./TextArea";

function EndOfDayBox() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestEndOfDay, setRequestEndOfDay] = useState(new RequestEndOfDay());
    const updateRequestEndOfDay = (updates) => {
        setRequestEndOfDay((requestEndOfDay) => {
            const newRequestEndOfDay = { ...requestEndOfDay, ...updates };
            return newRequestEndOfDay;
        });
    };

    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (isSubmitting)
            return;
        setIsSubmitting(true);

        try {
            const tagetUrl = urlFor(TARGET_END_OF_DAY);
            requestEndOfDay.auth_token = getAccessToken();
            await postJson(tagetUrl, requestEndOfDay);
            resetEOD();
            navigate("/home")
        } catch (err) {
            alert(err.response.error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelay = async () => {
        if (isSubmitting)
            return;
        setIsSubmitting(true);

        delayEOD();
        navigate("/home");
    };

    return (
        <div className="endofday-box">
            <TitleText
                text={"End of Day Feedback"}
            />

            <p>What types of questions did you ask the system? *</p>
            <TextArea
                onTextChanged={(types_text) => {
                    updateRequestEndOfDay({types: types_text});
                }}
            />

            <p>What types of questions do you think the system answered correctly, compared with your previous ways to solve problems during programming? *</p>
            <TextArea
                onTextChanged={(types_ext_ext) => {
                    updateRequestEndOfDay({types_ext: types_ext_ext});
                }}
            />

            <SelectOption
                promptText="How satisfied are you with the overall quality of the preferred answers? *"
                options={Object.values(OverallLevel)}
                onOptionSelect={(option) => {
                    updateRequestEndOfDay({overall: option});
                }}
            />

            { !isSubmitting &&
                <div className="endofday-box-buttons">
                    <Button
                        text={"Submit"}
                        onClick={handleSubmit}
                    />
                    <Button
                        text={"Delay"}
                        onClick={handleDelay}
                    />
                </div>
            }

        </div>
    );
}

export default EndOfDayBox;

